const Unauthorized = () => {
  return (
    <section className="container-center">
      <p style={{ marginTop: "3rem", fontSize: "1.5rem" }}>관리자 전용 페이지 입니다.</p>
    </section>
  );
};

export default Unauthorized;
